/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-09 14:06:17
 */
/**
 * 运营公司对账单
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import moment from 'moment';
import http from '@/assets/api/http';
import { isPlat } from '@/assets/js/authType';
import { XInput, XOKButton, XCancelButton, XSelect, showConfirm, XDatePicker } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import PayModal from './components/PayModal';
import ManualPay from './modal/ManualPay';
import model from '@/reducers/finance/microbusinessesstatements/model';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { message, Button } from 'antd';

class Main extends React.Component {

    state = {
        status: {},
        company: undefined,
        startDate: undefined,
        endDate: undefined,
        pageNum: 1,
        pageSize: 10,
        modalType: '',
        confirmLoading: false,
        generating: false
    }

    componentDidMount() {
        const { match, setBreadcrumbPaths, getStateList } = this.props;
        setBreadcrumbPaths(match);
        getStateList();
    }

    // 查询
    _searchHandle = (useCache) => {
        const { company, status, startDate, endDate, pageNum, pageSize } = this.state;
        this.searchCache = {
            targetName: company,
            verifyStatus: status.name,
            startDate: startDate && moment(startDate).format('YYYY-MM-DD'),
            endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
            // type: 'OPERATION',
            // startDate,
            // endDate,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getQueryReconciliations(this.searchCache);
        KeepAlive.saveCache({ ...this.state, modalType: '', pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ company: undefined, status: {}, startDate: undefined, endDate: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }
    // 生成对账单
    _newHandle = () => {
        this.setState({ modalType: 'statement' });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格操作
    _tableAction = (key, type) => {
        const { history } = this.props;
        switch (type) {
            case 'detail':
                history.push(`/home/finance/microbusinessesstatements/detail/${key}`);
                break;
            case 'export':
                window.open(key);
                break;
            case 'delete':
                showConfirm('确定删除？', '', () => {
                    http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReconService.del', { reconciliationId: key, isDelete: 1 }).then(res => {
                        message.success('删除成功!');
                        this._searchHandle('useCache');
                    }).catch((res) => {
                        message.error(res.message || '请求异常');

                    });
                });
                break;
            case 'sureAccount':
                showConfirm('对账单确认成功', '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.manualRemittance', { reconciliationId: key, verifyStatus: 'CONFIRM_SUCCESS' }).then(res => {
                        message.success('确认成功!');
                        this._searchHandle('useCache');
                    }).catch((res) => {
                        message.error(res.message || '请求异常');

                    });
                });

                break;
            case 'pay':
                this.setState({ modalType: 'pay', data: key });
                break;
        }
    }

    //打开弹窗
    _renderMode = () => {
        switch (this.state.modalType) {
            case 'pay':
                return <PayModal title='手工汇款' closeModal={this._closeModal} visible={true} reconciliationId={this.state.data} />;
            case 'statement':
                return <ManualPay title='生成对账单' closeModal={this._closeModal} visible={true} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (flag) => {
        if (flag) {
            this._searchHandle('useCache');
        }
        this.setState({ modalType: '' });
    }
    // 生成报表
    _generateReport = () => {
        this.setState({ generating: true });
        let templateId = 40;
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportTemplateService.info', { id: templateId }).then(res => {
            const { company, status, startDate, endDate } = this.state;
            const conds = {
                targetName: company,
                verifyStatus: status.name && { code: status.name, value: status.value },
                startDate: startDate && moment(startDate).format('YYYY-MM-DD'),
                endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
                type: 'OPERATION',
            };
            const queryCriteriaList = res.result.queryCriteriaList || [];
            queryCriteriaList.forEach(r => r.value = conds[r.conditionFiled]);

            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportRecordService.addReportRecord', {
                templateId,
                queryCriteriaList,
                purpose: '运营公司对账单报表-后台'
            }).then(res => {
                message.success('生成报表成功');
                this.setState({ generating: false });
            }).catch((res = {}) => {
                message.error(res.message || '生成报表异常');
                this.setState({ generating: false });

            });
        }).catch((res = {}) => {
            this.setState({ generating: false });
            message.error(res.message || '获取模板数据异常');
        });
    }


    render() {
        const { company, status, startDate, endDate, generating } = this.state;
        const { QueryReconciliations = { dataList: [], pageNum: 1, pageSize: 10 }, stateList = [] } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='企业名称'
                                placeholder='请输入'
                                value={company}
                                bindThis={this}
                                bindName='company'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '200px' }}
                                allowClear
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='name'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='对账周期'
                                value={startDate}
                                datePickerStyle={{ width: 200 }}
                                bindThis={this}
                                // picker="month"
                                showTime={false}
                                bindName='startDate'
                                isFormat
                                defaultTime='00:00:00'
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endDate}
                                showTime={false}
                                bindThis={this}
                                // picker="month"
                                bindName='endDate'
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    {isPlat() && <div className={styles.row2}>
                        {/* <Button
                            type='primary'
                            onClick={this._generateReport}
                            loading={generating}
                            style={{ width: 100, marginRight: 10, borderRadius: 4 }}
                        >生成报表</Button> */}
                        <XOKButton
                            style={{ width: 100 }}
                            label='生成对账单'
                            onClick={() => this._newHandle()}
                        />
                    </div>
                    }
                    <TableList renderData={QueryReconciliations} tableAction={this._tableAction} actionHandle={this._actionHandle} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,

    getQueryReconciliations: PropTypes.func,
    QueryReconciliations: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};

const mapStateToProps = (state) => ({
    stateList: state.microbusinessesstatements.stateList,
    QueryReconciliations: state.microbusinessesstatements.QueryReconciliations,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);